const timeDate = require('../../../../../js-handler/time-date')

function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

function trackingRows(result) {
  if (!result || !Array.isArray(result.multiTables)) return []
  const tracking = result.multiTables.find(table => table.tableName === 'sale_tracking_mail')
  if (!tracking || !Array.isArray(tracking.data)) return []
  return tracking.data.filter(row => row && row.id != null)
}

function cell(value) {
  const safeValue = escapeHtml(value)
  return `<td><div class="cell-data" title="${safeValue}"><span class="value-text">${safeValue}</span></div></td>`
}

export function render(result, fullcontHTML) {
  const container = fullcontHTML && fullcontHTML.querySelector('#customer-email-tracking')
  if (!container) return

  container.innerHTML = trackingRows(result).map(row => {
    const localDate = /^\d{4}-\d{2}-\d{2}$/.test(row.mail_date || '')
      ? `${row.mail_date}T00:00:00`
      : row.mail_date
    const sentDate = timeDate.friendlyDate(localDate, true)
    const sentTime = timeDate.friendlyTime(row.mail_time || '')
    const pdfUrl = `./server/php/queries/openSaleTrackingPdf.php?id=${encodeURIComponent(row.id)}`

    return `<cont data-tracking-id="${escapeHtml(row.id)}">
      <user>
        <photo class="photo" style="background-image: url('css/img/pic/person.svg')"></photo>
        <title>${escapeHtml(row.user_name)}</title>
        <time>${escapeHtml(sentDate)} | ${escapeHtml(sentTime)}</time>
      </user>
      <entry>
        <div class="dt-simple-fullcont">
          <table class="behaivor-quickview-table">
            <thead><tr><th>Email</th><th>Status</th><th>PDF</th><th>Info</th></tr></thead>
            <tbody><tr>
              ${cell(row.email)}
              ${cell(row.status)}
              <td><div class="cell-data"><a class="button-link" href="${pdfUrl}" target="_blank" rel="noopener noreferrer"><label>PDF</label></a></div></td>
              <td><div class="cell-data"><a class="button-link"><label data-detail='{"click":[{"dest":"ripple"},{"dest":"customer","elem":"dialog","act":"show","id":"emailStatusInfo"}]}'>INFO</label></a></div></td>
            </tr></tbody>
          </table>
        </div>
      </entry>
    </cont>`
  }).join('')
}

export function clean(fullcontHTML) {
  const container = fullcontHTML && fullcontHTML.querySelector('#customer-email-tracking')
  if (container) container.innerHTML = ''
}
